if (!Element.prototype.matches) {
	Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

// This is needed for some JS components
if (!Element.prototype.closest) {
	Element.prototype.closest = function(s) {
		var el = this;
		
		do {
			if (Element.prototype.matches.call(el, s)) {
				return el;
			}
			el = el.parentElement || el.parentNode;
		} while (el !== null && el.nodeType === 1);
		
		return null;
	};
}
